import { createActionGroup,props } from '@ngrx/store';
import { QualificationEntity } from '../../../../entities/mdqx/doctor/qualification.entity';
import { MutationChangeQualificationArgs,MutationDeleteQualificationArgs } from '../../../../mdqx-graphql-types';

export const QualificationActions = createActionGroup({
    source: 'qualification',
    events: {
        'Load Success': props<{ Payload: QualificationEntity[] }>(),
        'Load Request': props<{ Payload?: {} /*todo*/ }>(),
        'Load Failure': props<{ Errors: any; ToasterMessage?: string }>(),

        // 'Put Request': props<{ Payload: {}/*todo*/ }>(),
        'Put Failure': props<{ Errors: any; ToasterMessage?: string }>(),
        'Put Success': props<{ Payload: QualificationEntity[] }>(),

        'Change Request': props<{ Payload: MutationChangeQualificationArgs }>(),
        'Change Failure': props<{ Errors: any; ToasterMessage?: string }>(),
        'Change Success': props<{ Payload: QualificationEntity }>(),

        'delete Request': props<{ Payload: MutationDeleteQualificationArgs }>(),
        'delete Failure': props<{ Errors: any; ToasterMessage?: string }>(),
        'delete Success': props<{ Payload: number }>(),
    },
});
